import { useTranslation } from 'react-i18next';

import { entryPANMethods, TEntryPANMethodType } from '@/features/cards/store/models/card.model';
import { PaymentTruncateCell } from '@/features/cards/components/CardTransactionsTable/PaymentTruncateCell';

interface IPaymentPANEntryMethodCellProps {
  entryMethod?: TEntryPANMethodType;
  shouldTrancate?: boolean;
}

export function PaymentPANEntryMethodCell({ entryMethod, shouldTrancate = true }: IPaymentPANEntryMethodCellProps) {
  const { t } = useTranslation();
  if (!entryMethod) return <></>;

  const description = entryPANMethods.includes(entryMethod)
    ? [entryMethod, t(`pages.currentProfiles.cards.transactions.table.headers.entryPANMethods.${entryMethod}`)].join(
        ': ',
      )
    : entryMethod;

  return shouldTrancate ? (
    <PaymentTruncateCell textString={description} />
  ) : (
    <span className="typo-body-regular-paragraph text-secondary">{description}</span>
  );
}
